import moment from 'moment';
import React, { useState } from 'react';
import { getLocale } from 'umi';
import { Modal, Form, Input, Button, TextArea } from 'tea-component';
import DateSelect from '@op/components/FilterCommon/widgets/DateSelect';
import useLanguage from '@op/hooks/useLanguage';

interface CreateVersionProps {
  data?: {
    // 编辑情况下传入的表单数据
    id: number;
    game_id: string;
    version_name: string;
    white_paper: string;
    effective_start_time: string;
    effective_end_time: string;
    status: number;
  };
  closeModal: () => void;
  inputContentStatus: boolean;
  handleInputContentStatus: (value: boolean) => void;
  gameInfo: any;
  handleVersion: (params: any) => void;
  loading: boolean;
}

export default function CreateVersion({
  data,
  closeModal,
  inputContentStatus,
  handleInputContentStatus,
  gameInfo,
  handleVersion,
  loading,
}: CreateVersionProps) {
  const { formatMessage } = useLanguage();
  // 版本名称、有效事件、白皮书
  const [versionName, setVersionName] = useState(data?.version_name || '');
  const [effectiveTime, setEffectiveTime] = useState({
    start_time: data?.effective_start_time || moment().format('YYYY-MM-DD'),
    end_time: data?.effective_end_time || moment().format('YYYY-MM-DD'),
    date_type: 'daily',
  });
  const [whitePaper, setWhitePaper] = useState(data?.white_paper || '');

  // 提交事件
  const submits = () => {
    // 判断必填值内容
    if (versionName && effectiveTime) {
      const params = {
        ...(data?.id && { id: data.id }),
        version_name: versionName,
        white_paper: whitePaper,
        effective_start_time: effectiveTime.start_time,
        effective_end_time: effectiveTime.end_time,
        status: 1,
      };

      handleVersion(params);
    } else {
      handleInputContentStatus(true);
    }
  };

  return (
    <Modal
      className="dbo-customized-reports-modal"
      caption={
        data?.version_name
          ? formatMessage('Edit a version')
          : formatMessage('Add a new version')
      }
      visible
      onClose={() => closeModal()}
    >
      <Modal.Body>
        <Form>
          <Form.Item
            required
            showStatusIcon={false}
            label={formatMessage('Version Name')}
            status={inputContentStatus && !versionName ? 'error' : undefined}
            message={inputContentStatus && !versionName ? formatMessage('Please enter the version name') : ''}
          >
            <Input
              size="full"
              value={versionName}
              onChange={(value) => {
                setVersionName(value);
              }}
              placeholder={formatMessage('Please enter')}
            />
          </Form.Item>
          <Form.Item
            label={formatMessage('Effective Date')}
            required
            showStatusIcon={false}
            status={inputContentStatus && !effectiveTime ? 'error' : undefined}
          >
            <div style={{ marginTop: '-10px' }}>
              <DateSelect
                dateTypeList={['date']}
                lang={getLocale()}
                gameInfo={gameInfo}
                showTimeTips={false}
                noLimitation
                defaultOptionsMap={{
                  date: { value: 'date', text: 'Day', text_cn: '日' },
                }}
                filterOptions={{ time: moment().format('YYYY-MM-DD') }}
                defaultValue={effectiveTime}
                onChange={(timeKey: any, result: any) => {
                  if (result?.value?.start_time && result?.value?.end_time) {
                    setEffectiveTime(result?.value);
                  }
                }}
              />
            </div>
          </Form.Item>
          <Form.Item label={formatMessage('White Paper')}>
            <TextArea
              size="full"
              value={whitePaper}
              onChange={(value) => {
                setWhitePaper(value);
              }}
              placeholder={formatMessage('Please enter')}
            />
          </Form.Item>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button loading={loading} type="primary" onClick={submits}>
          {formatMessage('Confirm')}
        </Button>
        <Button
          type="weak"
          onClick={() => {
            closeModal();
            handleInputContentStatus(false);
          }}
        >
          {formatMessage('Cancel')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
